import {effect, inject, Injectable, signal, WritableSignal} from '@angular/core';
import {components} from '../configs/config';
import {LanguageService} from './language.service';

@Injectable({
  providedIn: 'root'
})
export class CommonTextService {

  languageService: LanguageService = inject(LanguageService);
  commonTexts: WritableSignal<any> = signal(null);
  constructor() {
    this.refreshContent();
    effect(async () => {
      if (this.languageService.lang()) {
        await this.refreshContent();
      }
    });
  }
  async refreshContent() {
    const commonTexts = await this.languageService.loadContent(components.commonTexts);
    this.commonTexts.set(commonTexts);
  }
}
